import { DayOfWeek } from '@/shared/types/generated';

/**
 * How far ahead (in days) stylists can set availability and clients can book.
 * Keep in sync with AVAILABILITY_HORIZON_DAYS in packages/backend/src/shared/constants.ts.
 */
export const AVAILABILITY_HORIZON_DAYS = 28;

export const DAYS_OF_WEEK: Array<{ key: DayOfWeek; label: string }> = [
  { key: DayOfWeek.Sunday, label: 'Sunday' },
  { key: DayOfWeek.Monday, label: 'Monday' },
  { key: DayOfWeek.Tuesday, label: 'Tuesday' },
  { key: DayOfWeek.Wednesday, label: 'Wednesday' },
  { key: DayOfWeek.Thursday, label: 'Thursday' },
  { key: DayOfWeek.Friday, label: 'Friday' },
  { key: DayOfWeek.Saturday, label: 'Saturday' },
];

// Current supported timezones
export enum Timezone {
  Eastern = 'America/New_York',
  Central = 'America/Chicago',
  Mountain = 'America/Denver',
  Pacific = 'America/Los_Angeles',
  Alaska = 'America/Anchorage',
  Hawaii = 'America/Honolulu',
  Arizona = 'America/Phoenix',
}

export const US_TIMEZONES = [
  { label: 'Eastern Time (ET)', value: Timezone.Eastern },
  { label: 'Central Time (CT)', value: Timezone.Central },
  { label: 'Mountain Time (MT)', value: Timezone.Mountain },
  { label: 'Pacific Time (PT)', value: Timezone.Pacific },
  { label: 'Alaska Time (AKT)', value: Timezone.Alaska },
  { label: 'Hawaii Time (HT)', value: Timezone.Hawaii },
  { label: 'Arizona Time (No DST)', value: Timezone.Arizona },
];

export enum AvailabilityStep {
  CalendarConnection = 0,
  Availability = 1,
  Booking = 2,
  TimeZoneSelection = 3,
  Schedule = 4,
}

export const TIME_OPTIONS = Array.from({ length: 16 * 4 + 1 }, (_, i) => {
  const totalMinutes = i * 15 + 7 * 60; // Start at 7am and go to 11pm
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const period = hours < 12 ? 'am' : 'pm';
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;

  return {
    label: `${displayHours}:${minutes.toString().padStart(2, '0')}${period}`,
    value: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`,
  };
});

export const STEPS_IN_ORDER: AvailabilityStep[] = [
  AvailabilityStep.CalendarConnection,
  AvailabilityStep.Availability,
  AvailabilityStep.Booking,
  AvailabilityStep.TimeZoneSelection,
  AvailabilityStep.Schedule,
];
